import {
  AreaChart,
  Area,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
  TooltipProps,
} from "recharts";
import { Clock } from "lucide-react";
import { CHART_COLORS } from "./chartTokens";
import { formatDecimal } from "@/utils";

type TimeSavedGraphCardProps = {
  hours: number;
  data: { name: string; value: number }[];
};

const CustomTooltip = ({ active, payload }: TooltipProps<number, string>) => {
  if (active && payload && payload.length) {
    const value = payload[0].value;
    const name = payload[0].payload.name;
    const roundedValue = typeof value === "number" ? formatDecimal(value, 1) : "0,0";

    return (
      <div className="rounded-md border border-border bg-card p-3 shadow-md">
        <p className="text-sm font-semibold text-palomma-primary">{name}</p>
        <p className="text-sm font-medium text-palomma-secondary">{roundedValue} hrs</p>
      </div>
    );
  }
  return null;
};

export const TimeSavedGraphCard = ({ hours, data }: TimeSavedGraphCardProps) => {
  return (
    <div className="relative h-[160px] overflow-hidden rounded-2xl border border-border bg-card p-6 md:h-[180px]">
      <div className="flex flex-col items-start gap-2">
        <div className="flex items-center">
          <div className="mr-3 flex h-10 w-10 items-center justify-center rounded-full bg-muted">
            <Clock className="size-[18px] text-palomma-primary" />
          </div>
          <h3 className="text-sm font-semibold text-palomma-secondary">
            Horas de agente humano ahorradas
          </h3>
        </div>
        <p className="ml-[52px] text-3xl font-bold text-palomma-secondary">
          {formatDecimal(hours, 1)} hrs
        </p>
      </div>

      <div className="absolute bottom-0 left-0 h-[80px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={CHART_COLORS.primary} stopOpacity={0.8} />
                <stop offset="100%" stopColor={CHART_COLORS.primary} stopOpacity={0.1} />
              </linearGradient>
            </defs>
            <XAxis dataKey="name" hide={true} />
            <YAxis hide={true} />
            <Tooltip content={<CustomTooltip />} />
            <Area
              type="monotone"
              dataKey="value"
              stroke={CHART_COLORS.primary}
              fillOpacity={1}
              fill="url(#colorGradient)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default TimeSavedGraphCard;
